<form class="" [formGroup]="formulario">
  <div class="ps-form-relation-field-container">
    <div class="ps-row" fxLayout="row">
      <div fxFlex>
        <p class="ps-description-14">
          Nesta tela será possível criar uma relação entre os campos do sistema. O valor preenchido em campos vinculados
          definem os valores exibidos nos mesmos.
        </p>
      </div>
    </div>

    <div class="ps-row" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
      <div fxFlex="40">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>Selecione um campo</mat-label>
          <input
            type="text"
            matInput
            formControlName="relation_field"
            [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" required>
            <mat-option 
              *ngFor="let field of fields | async; let i = index"
              [value]="field">
              {{field.label}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="ps-button-add-relation-content" fxFlex>
        <a [disabled]="editorMode"
          class="ps-button-add-relation"
          (click)="relating()"
          mat-stroked-button
          color="primary">
          <mat-icon>add</mat-icon>
          Vincular
        </a>
      </div>
    </div>

    <div fxLayout="row" *ngIf="relatedFields.length > 0">
      <div fxFlex>
        <span class="ps-label-chips-toggle">Campos vinculados ao campo {{dateField.label}}</span>
        <mat-chip-list>
          <mat-chip
            *ngFor="let relation of relatedFields"
            [ngClass]="{'ps-relation-hidden-chip': relation.field_id === dateField.field_id}"
            [removable]="removable"
            (removed)="remove(relation)">
            {{relation.label}}
            <mat-icon
              matChipRemove
              *ngIf="removable">
              cancel
            </mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div>
</form>
